/**
 * Access-токен хранится только в памяти — защита от XSS (не в localStorage).
 * Сессия восстанавливается через httpOnly refresh-cookie при перезагрузке страницы.
 */

let _accessToken = null;

export function getWellandStoredToken() {
    return _accessToken;
}

export function setWellandToken(token) {
    _accessToken = (token && typeof token === 'string') ? token : null;
}

export function clearWellandToken() {
    _accessToken = null;
}

// Ключ для профиля пользователя (не секрет — публичные данные профиля)
export const WELLAND_USER_KEY = 'welland_user';

const WELLAND_SKIP_DASHBOARD_ME_ONCE = 'welland_skip_dashboard_me_once';

export function markProfileJustLoadedSkipDashboardMe() {
    try {
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem(WELLAND_SKIP_DASHBOARD_ME_ONCE, '1');
        }
    } catch {
        /* ignore */
    }
}

/** @returns {boolean} true если флаг был выставлен (и снят). */
export function consumeSkipDashboardMeOnce() {
    try {
        if (typeof sessionStorage === 'undefined') return false;
        if (sessionStorage.getItem(WELLAND_SKIP_DASHBOARD_ME_ONCE) !== '1') return false;
        sessionStorage.removeItem(WELLAND_SKIP_DASHBOARD_ME_ONCE);
        return true;
    } catch {
        return false;
    }
}

export function clearDashboardMeSkipFlag() {
    try {
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem(WELLAND_SKIP_DASHBOARD_ME_ONCE);
        }
    } catch {
        /* ignore */
    }
}
